import React, { useState } from "react";
import NewsCard from "./NewsCard";
import Modal from "../shared/Modal";

const NewsFeed = ({
  news = [],
  tabs = [],
  activeTab,
  onTabChange,
  sources = [],
  selectedSources = [],
  onSourceClick,
  onShowAISummary,
  onAddToResearch,
  newsSourceDisplayNames = {},
}) => {
  // State for full story modal
  const [showFullStory, setShowFullStory] = useState(false);
  const [fullStoryArticle, setFullStoryArticle] = useState(null);

  const handleShowFullStory = (article) => {
    setFullStoryArticle(article);
    setShowFullStory(true);
  };
  const handleCloseFullStory = () => {
    setShowFullStory(false);
    setFullStoryArticle(null);
  };

  return (
    <div>
      {/* Tab Navigation */}
      <div className="border-b border-gray-200 dark:border-gray-700 mb-4">
        <nav className="flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => onTabChange(tab)}
              className={`py-2 px-1 text-sm font-medium border-b-2 ${
                activeTab === tab
                  ? "border-[#029831] text-[#029831]"
                  : "border-transparent text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:text-gray-100 hover:border-gray-300"
              }`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          ))}
        </nav>
      </div>
      {/* Filter Bar */}
      <div className="mb-4">
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Filter News Sources:
        </h3>
        <div className="flex flex-wrap gap-2">
          {sources.map((source) => (
            <button
              key={source}
              onClick={() => onSourceClick(source)}
              className={`px-3 py-1 rounded-full text-sm font-medium transition-colors
                ${
                  selectedSources.includes(source)
                    ? "bg-green-100 text-green-800 border-2 border-green-600"
                    : "bg-gray-100 text-gray-800 dark:text-gray-200 border-2 border-transparent hover:border-gray-300"
                }`}
            >
              {newsSourceDisplayNames[source] || source}
            </button>
          ))}
        </div>
      </div>
      {/* News List */}
      <div className="space-y-4">
        {news && news.length > 0 ? (
          news.map((item) => (
            <NewsCard
              key={item.id}
              news={item}
              onShowAISummary={() => onShowAISummary(item)}
              onAddToResearch={() => onAddToResearch(item)}
              onShowFullStory={() => handleShowFullStory(item)}
            />
          ))
        ) : (
          <div className="bg-surface-default dark:bg-surface-default rounded-lg shadow p-6 text-center">
            <p className="text-gray-700 dark:text-gray-300">No articles available for the selected filters.</p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">Try adjusting your filters or selecting a different category.</p>
          </div>
        )}
      </div>
      {/* Full Story Modal */}
      <Modal isOpen={showFullStory && !!fullStoryArticle} onClose={handleCloseFullStory}>
        <div className="p-6">
          <div className="flex justify-between items-start mb-4">
            <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">
              {fullStoryArticle?.title}
            </h2>
            <button
              onClick={handleCloseFullStory}
              className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
            >
              ✕
            </button>
          </div>
          <div className="mb-2 text-sm text-gray-600 dark:text-gray-400">
            <span>{fullStoryArticle?.time}</span>
            <span className="mx-2">•</span>
            <span>{fullStoryArticle?.source}</span>
          </div>
          <div className="mb-4 text-gray-900 dark:text-gray-100">{fullStoryArticle?.summary}</div>
          <a
            href={fullStoryArticle?.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-green-700 hover:text-green-800 dark:text-green-500 dark:hover:text-green-400 underline"
          >
            Read original article
          </a>
        </div>
      </Modal>
    </div>
  );
};

export default NewsFeed;
